import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer style={{ marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid var(--border)', color: 'var(--text-secondary)' }}>
            {/* Navigation Links */}
            <nav style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '2rem',
                marginBottom: '1.5rem',
                flexWrap: 'wrap',
                fontSize: '0.9rem'
            }}>
                <Link to="/" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                    Calculator
                </Link>
                <Link to="/blog" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                    Blog
                </Link>
                <Link to="/resources" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                    Resources
                </Link>
                <Link to="/faq" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                    FAQ
                </Link>
                <Link to="/about" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                    About
                </Link>
            </nav>

            {/* Copyright and Contact */}
            <div style={{ textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: '0.9rem' }}>
                    © {new Date().getFullYear()} Principal Saver. All rights reserved.
                </p>
                <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.875rem' }}>
                    Contact: <a href="mailto:rupdevworks@gmail.com" style={{ color: 'var(--primary)', textDecoration: 'none' }}>rupdevworks@gmail.com</a>
                </p>
            </div>
        </footer>
    );
}

export default Footer;
